(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyDetailController', PublicSitePartKeyDetailController);

    PublicSitePartKeyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSitePartKey', 'PublicSitePart'];

    function PublicSitePartKeyDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSitePartKey, PublicSitePart) {
        var vm = this;

        vm.publicSitePartKey = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSitePartKeyUpdate', function(event, result) {
            vm.publicSitePartKey = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
